import {useCallback} from 'react';
import PropTypes from 'prop-types';
import toast from 'react-hot-toast';
import {Box, Button, Divider, Popover, Typography} from '@mui/material';
import {useAuth} from 'src/hooks/auth/use-auth';
import {useRouter} from 'src/hooks/use-router';
import {paths} from 'src/paths';
import Swal from "sweetalert2";
import KeyIcon from '@mui/icons-material/Key';
import LogoutIcon from "@mui/icons-material/Logout";
import {useTheme} from "@mui/material/styles";

export const AccountPopover = (props) => {
    const {anchorEl, onClose, open, ...other} = props;
    const router = useRouter();
    const auth = useAuth();
    const user = auth.user ?? null;
    let profile = auth.getProfile()
    let themes = useTheme()
    const handleLogout = useCallback(async () => {
        Swal.fire({
            title: 'ต้องการออกจากระบบ?',
            backdrop: true,
            allowOutsideClick: false,
            showCancelButton: true,
            confirmButtonText: 'ตกลง',
            cancelButtonText: 'ยกเลิก',
            confirmButtonColor: `${themes.palette.primary.main}`,

        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    onClose?.();
                    await auth.signOut();

                } catch (err) {
                    console.error(err);
                    toast.error('Something went wrong!');
                }
            }
        })

    }, [auth, router, onClose]);
    return (
        <Popover
            anchorEl={anchorEl}
            anchorOrigin={{
                horizontal: 'center',
                vertical: 'bottom'
            }}
            disableScrollLock
            onClose={onClose}
            open={!!open}
            PaperProps={{sx: {width: 200}}}
            {...other}>
            <Box sx={{px: 2, textAlign: "center"}}>
                <Typography variant="body1">
                    {(profile && profile?.name) ?? ""}
                </Typography>
            </Box>
            <Divider/>
            <Button
                startIcon={<KeyIcon/>}
                color="inherit"
                onClick={() => window.location.href = paths.changePassword}
                size="small"
                fullWidth
            >
                เปลี่ยนรหัสผ่าน
            </Button>
            <Divider sx={{my: '0 !important'}}/>
            <Button
                startIcon={<LogoutIcon/>}
                fullWidth
                color="inherit"
                onClick={handleLogout}
                size="small"
            >
                ออกจากระบบ
            </Button>
        </Popover>
    );
};

AccountPopover.propTypes = {
    anchorEl: PropTypes.any,
    onClose: PropTypes.func,
    open: PropTypes.bool
};
